/**
 * Queue Restore API
 *
 * API endpoints for queue restore operations
 */

import toast from "react-hot-toast";

import { nextCargoApi } from "../../baseApi";
import type { QueueRestore, SaveQueueRestore } from "./queueRestore.types";

/**
 * Queue Restore API endpoints
 */
export const queueRestoreApi = nextCargoApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Get all queue restore entries
     */
    getQueueRestores: build.query<QueueRestore[], void>({
      query: () => `/queue-restore`
    }),

    /**
     * Restore the queue by company and queue ids
     */
    saveQueueRestore: build.mutation<SaveQueueRestore, { id: number; company: { id: string } }>({
      query: (body) => ({
        url: "/queue-restore/restore",
        method: "PUT",
        body
      }),
      onQueryStarted: (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Realidando resgate...",
          success: "Resgate realizado com sucesso!",
          error: "Erro ao efetuar o resgate!"
        });
      },
      extraOptions: {
        maxRetries: 3
      }
    })
  })
});

// Enhance endpoints with tag types
queueRestoreApi.enhanceEndpoints({
  addTagTypes: ["QueueRestore"],
  endpoints: {
    getQueueRestores: {
      providesTags: (result) => {
        if (!result) return [{ type: "QueueRestore", id: "LIST" }];

        return [
          ...result.map(({ id }) => ({
            type: "QueueRestore" as const,
            id
          })),
          { type: "QueueRestore", id: "LIST" }
        ];
      }
    },
    saveQueueRestore: {
      invalidatesTags: ["QueueRestore"]
    }
  }
});
